import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	jobDepartmentList: [],
	jobTypeList: [],
	jobLocationList: [],
};
const filterSlice = createSlice({
	name: "filterSlice",
	initialState: initialState,
	reducers: {
		setDepartmentList(state, action) {
			state.jobDepartmentList = action.payload;
		},
		setJobTypeList(state, action) {
			state.jobTypeList = action.payload;
		},
		setLocationList(state, action) {
			state.jobLocationList = action.payload;
		},
	},
});

export const FilterActions = filterSlice.actions;
export default filterSlice.reducer;
